export { default as NewHomesListingSchema } from './new-homes-listing-schema.jsx';
